import { render, staticRenderFns } from "./WaveSearch.vue?vue&type=template&id=2b28f343"
import script from "./WaveSearch.vue?vue&type=script&lang=js"
export * from "./WaveSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports